import React from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";
import logo from "../../images/rethinkpack.png";

const Navbar = () => {
  return (
    <AppBar position="static">
      <Toolbar>
        <Box
          component="a"
          href="https://rethinkpack.com"
          sx={{
            height: 40,
            mr: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="RethinkPack Logo"
            sx={{
              height: 40,
            }}
          />
        </Box>
        <Box sx={{ flexGrow: 1 }} /> {/* Spacer */}
        <Button
          color="inherit"
          onClick={() => (window.location.href = "https://rethinkpack.com/login")}
        >
          Login
        </Button>
        
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
